export default "__VITE_ASSET__CcHDJcBd__"